import React, { useContext, useEffect, useState } from 'react'
import { AuthContext } from '../../Providers/AuthProviders'
import { allSelectedClass, deleteSelectedClass, enrollClass } from '../../API/class'

function SelectedClasses() {
    const { user } = useContext(AuthContext)
    const [data, setData] = useState([])
    const [reload, setReload] = useState(false)

    useEffect(() => {
        allSelectedClass(user?.email)
            .then(res => res.json())
            .then(data => setData(data))
    }, [user, reload])

    const handleDelete = (id) => {
        deleteSelectedClass(id)
            .then(data => {
                if (data.deletedCount === 1) {
                    setReload(!reload)
                }
            })
    }

    const handlePay = (id) => {
        enrollClass(id)
            .then(data => {
                if (data.modifiedCount === 1) {
                    setReload(!reload)                    
                }
            })
    }

    return (
        <>
            <p className='text-center font-bold text-5xl tracking-tight pt-10 font-serif dark:text-white'>My Selected Classes</p>
            <div className='max-w-[85%] mx-auto mt-8 pb-16'>
                <div className="relative overflow-x-auto sm:rounded-lg">
                {data.length > 0 ? (<table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                        <thead className="text-xs text-center text-gray-700 uppercase bg-green-100 dark:bg-gray-700 dark:text-gray-400">
                            <tr>
                                <th scope="col" className="px-6 py-3">
                                    No.
                                </th>
                                <th scope="col" className="py-3 text-left">
                                    Image
                                </th>
                                <th scope="col" className="py-3 text-left">
                                    Class Name
                                </th>
                                <th scope="col" className="py-3">
                                    Instructor
                                </th>
                                <th scope="col" className="py-3">
                                    Email
                                </th>
                                <th scope="col" className="py-3">
                                    Price
                                </th>
                                <th scope="col" className="px-6 py-3">
                                    Delete
                                </th>
                                <th scope="col" className="px-6 py-3">
                                    Enroll
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                data.map((d, i) =>
                                    <tr key={d._id} className="bg-white text-center border-b dark:bg-gray-700 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600">
                                        <td className="w-4 p-4">
                                            <div className="flex ps-2 items-center">
                                                {i + 1}
                                            </div>
                                        </td>
                                        <td>
                                            <img className='w-16' src={d.classImage} alt="" />
                                        </td>
                                        <td className="py-4 font-medium text-gray-700 text-left whitespace-nowrap dark:text-white">
                                            {d.className}
                                        </td>
                                        <td className="py-4">
                                            {d.instructor.name}
                                        </td>
                                        <td className="py-4">
                                            {d.instructor.email}
                                        </td>
                                        <td className="px-4 py-4 text-right">
                                            ${d.price}
                                        </td>
                                        <td className="px-6 py-4">
                                            <button onClick={() => handleDelete(d._id)} type="button">
                                                <img className='w-6' src="https://freepngimg.com/download/trash_can/164880-basket-trash-png-free-photo.png" alt="" />
                                            </button>
                                        </td>
                                        <td className="px-6 py-4">
                                            <button onClick={() => handlePay(d._id)} type="button" className="text-white bg-emerald-500 hover:bg-emerald-600 focus:outline-none font-medium rounded-full text-sm px-5 py-2.5 text-center">Pay Now</button>
                                        </td>
                                    </tr>
                                )
                            }
                        </tbody>
                    </table>) : (
                        <h1 className="text-2xl lg:text-5xl py-20 font-bold text-center text-gray-400">No Classes Enrolled</h1>
                    )}                    
                </div>
            </div>
        </>
    )
}

export default SelectedClasses